<template>
    <div>
      <p><i class="nc-icon nc-alert-circle-i" style="margin-right: 5px" /><span v-html="data.message"></span></p>
      <div class="col-md-12 text-center">
        <button @click="closeModal" class="btn btn-fill btn-info btn-wd">Yes</button>
        <button @click="resetStatusAndCloseModal" class="btn btn-fill btn-info btn-wd">No</button>
      </div>
    </div>
</template>

<script>
  export default {
    props: ['data'],
    methods: {
      resetStatusAndCloseModal() {
        this.$eventHub.$emit('resetJobStatus', this.data.initialStatus)
        this.$emit('close')
      },
      closeModal() {
        this.$eventHub.$emit('confirmedCompleteOrCancel')
        this.$emit('close')
      }
    }
  }
</script>
